<template>
    <div v-if="pages >= 2" class="d-flex flex-wrap justify-content-end align-items-center w-100 px-0 text-right mt-3" :class="position">
        <label class="mx-0 mb-3 pt-0 pb-0 mb-0 text-nowrap info-text" v-if="customMessage">
            {{customMessage}}
        </label>

        <label class="mr-3 mb-3 mb-0 text-nowrap info-text" v-else-if="total">
            Mostrando {{ localValue == (pages - 1) ? total : (localValue + 1) * pageSize }} de {{ total }}
        </label>

        <div v-else class="spinner-border spinner-border-sm mr-3 header-text-color" role="status">
            <span class="sr-only">Loading...</span>
        </div>

        <div class="btn-container mb-3">
          <button class="btn btn-default page-btn" @click.prevent="changePage(localValue - 1)" v-if="localValue > 0"> 
            <i class="fas fa-angle-left"></i>
          </button>
          <template v-for="(page, index) in pages">
            <div v-if="Math.abs(page - localValue) < 2 || (Math.abs(page - localValue) < 3) || (page <= 3 && localValue < 2)" :key="index">
              <button v-show="localValue == page || localValue == (page - 1) || localValue == (page - 2) || (page == 3 && localValue < 2) || (localValue == (page + 1) && localValue > (pages - 2))" class="btn nmb-btn"
                @click.prevent="changePage(page - 1)"
                :class="{
                    active: (localValue + 1) === page, 
                    current: localValue === page, 
                    last: (page == pages - 1 && Math.abs(page - localValue) >= 3), 
                    first:(page == 0 && Math.abs(page - localValue) >= 3)
                }"> 
                    {{ page }} 
                </button>
            </div>
          </template>
          <button class="btn btn-default page-btn" @click.prevent="changePage(localValue + 1)" v-if="localValue <= (pages - 2)">
            <i class="fas fa-angle-right"></i>
          </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        pages: Number,
        total: Number,
        pageSize: Number,
        customMessage: {
            type: [Boolean, String],
            default: false
        },
        value: {
            type: Number,
            required: true
        },
        position: {
            type: String,
            default: "align-items-center justify-content-between justify-content-md-end"
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    methods: {
        changePage(newPage) {
            this.localValue = newPage;
        }
    }
}
</script>
<style lang="scss" scoped>
.info-text {
    color: #6E7176;
    font-size: .85em;
}

.page-btn {
    background-color: #F80048;
    color: #fff;
}

.btn-container {
    display: flex;
    justify-content: flex-end;
    margin-left: 1rem;
}

.nmb-btn {
    background-color: #fff;
    color: #535353;
}

.active {
    color: #F80048;
    font-weight: 800;
    background-color: #fff
}
</style>